// Mock data for Tropic Blue website

export const navLinks = [
  { label: 'HOME', href: '#home' },
  { label: 'ABOUT US', href: '#about' },
  { label: 'PRODUCTS', href: '#products' },
  { label: 'QUALITY', href: '#quality' },
  { label: 'CERTIFICATIONS', href: '#certifications' },
  { label: 'SUSTAINABILITY', href: '#sustainability' },
  { label: 'DISTRIBUTOR', href: '#distributor' },
  { label: 'CONTACT', href: '#contact' },
];

export const heroFeatures = [
  { icon: 'Droplet', label: 'PURE WATER' },
  { icon: 'ShieldCheck', label: 'PREMIUM\nPACKAGING' },
  { icon: 'Award', label: 'TRUSTED\nQUALITY' },
  { icon: 'Leaf', label: 'SUSTAINABLE\nAPPROACH' },
];

export const brandIdentityItems = [
  {
    icon: 'BadgeCheck',
    title: 'REGISTERED TRADEMARK',
    description:
      'Tropic Blue\u00AE is a protected trademark representing our commitment to quality, authenticity and consumer trust.',
  },
  {
    icon: 'FileBadge',
    title: 'REGISTERED BOTTLE DESIGN',
    description:
      'Our exclusive bottle design is protected under Design Registration laws, ensuring uniqueness in appearance and brand recognition.',
  },
  {
    icon: 'Copyright',
    title: 'COPYRIGHT PROTECTED ASSETS',
    description:
      'All logos, artwork, labels, photographs, packaging concepts, website content and marketing materials are protected intellectual property.',
  },
  {
    icon: 'ShieldAlert',
    title: 'ANTI-COUNTERFEITING COMMITMENT',
    description:
      'Consumers and distributors are advised to purchase only genuine Tropic Blue\u00AE products from authorized channels.',
  },
];

export const bottleDesignPoints = [
  'Strong shelf presence',
  'Brand recognition',
  'Premium consumer experience',
  'Protection against imitation',
];

export const products = [
  { size: '200ml', tag: 'Ideal for events,\nhospitality and airlines.', width: 'w-16' },
  { size: '250ml', tag: 'Premium compact\nhydration.', width: 'w-20' },
  { size: '500ml', tag: 'Daily on-the-go\nhydration.', width: 'w-24' },
  { size: '1L', tag: 'Personal\nconsumption.', width: 'w-28' },
  { size: '2L', tag: 'Family hydration\nsolution.', width: 'w-32' },
];

export const qualityProcess = [
  { icon: 'Mountain', label: 'Raw Water\nCollection' },
  { icon: 'Layers', label: 'Sand\nFiltration' },
  { icon: 'Filter', label: 'Activated\nCarbon Filtration' },
  { icon: 'CircleDot', label: 'Reverse\nOsmosis' },
  { icon: 'FilterX', label: 'Micron\nFiltration' },
  { icon: 'Sun', label: 'UV\nSterilization' },
  { icon: 'Atom', label: 'Ozonation' },
  { icon: 'Cog', label: 'Automated\nFilling' },
  { icon: 'ClipboardCheck', label: 'Quality\nInspection' },
  { icon: 'Package', label: 'Sealed\nPackaging' },
];

export const certifications = [
  { name: 'FSSAI', img: 'fssai' },
  { name: 'MSME', img: 'msme' },
  { name: 'BIS (If Applicable)', img: 'bis' },
];

export const sustainabilityItems = [
  { icon: 'Gem', label: 'Heavyweight,\nInfinitely\nRecyclable Vessels' },
  { icon: 'Recycle', label: 'Responsible\nWater\nManagement' },
  { icon: 'RotateCcw', label: 'Recyclable\nPackaging' },
  { icon: 'TrendingDown', label: 'A Lighter\nFootprint' },
];

export const sustainabilityStatement =
  'Weight, permanence, and purpose. Encased in heavyweight, infinitely recyclable vessels and crafted through responsible water management, true luxury leaves a lighter footprint.';

export const distributorBenefits = [
  'Strong Brand Identity',
  'Registered Bottle Design',
  'Marketing Support',
  'Attractive Margins',
  'Reliable Supply Chain',
];

export const chairman = {
  name: 'Prateek Krishan Sharma',
  title: 'Chairman & Director',
  company: 'Tropic Blue\u00AE',
  message:
    'At Tropic Blue\u00AE, our mission is simple \u2014 to deliver pure, safe and premium hydration while continuously innovating in packaging, quality and customer satisfaction. Every bottle reflects our commitment to excellence and trust.',
};

export const contactInfo = {
  address: 'Noida, U.P., 201301',
  phone: '+91-9911600060',
  email: 'hello@tropicblue.in',
  website: 'www.tropicblue.in',
};

export const IMAGES = {
  mountainBg: 'https://images.pexels.com/photos/13862168/pexels-photo-13862168.jpeg',
  natureBg: 'https://images.pexels.com/photos/9213600/pexels-photo-9213600.jpeg',
  earthSustain: 'https://images.pexels.com/photos/10954153/pexels-photo-10954153.jpeg',
  waterSplash: 'https://images.pexels.com/photos/5421109/pexels-photo-5421109.jpeg',
};

// Real Tropic Blue bottle photos
export const BOTTLES = {
  boat: '/bottles/boat.webp',
  mini: '/bottles/mini.webp',
  mist200: 'https://customer-assets-wrfwihn1.emergentagent.net/job_3f8db539-d683-4254-b254-99ad2d7a4457/artifacts/tvypuxho_mist%20200ml.jpeg',
  mist250: '/bottles/mist.webp',
  mist: '/bottles/mist.webp',
  neo: '/bottles/neo.webp',
  plus: '/bottles/plus.webp',
};

// Bird logo (tropicbluebird.webp) - contains 3 logos side-by-side; middle is used
export const BRAND_LOGO = 'https://customer-assets-wrfwihn1.emergentagent.net/job_3f8db539-d683-4254-b254-99ad2d7a4457/artifacts/l8v6gmcj_Tropic%20blue%20bird.webp';

// Transparent circular hummingbird logo (background removed) — used in footer
export const BRAND_BIRD_LOGO = '/tropic-bird-logo.png';

// Transparent wordmark (TROPIC black serif + blue script, background removed) — used in navbar
export const BRAND_WORDMARK = '/tropic-wordmark.png';

// Auto-cycling hero carousel — showcasing all bottle variants
export const heroBottleCarousel = [
  { key: 'mini', label: 'Mini', size: '200ml', img: BOTTLES.mini, tagline: 'Compact luxury for events & travel.' },
  { key: 'mist200', label: 'Mist', size: '200ml', img: BOTTLES.mist200, masked: true, tagline: 'Vibrant. Playful. Refreshing.' },
  { key: 'mist250', label: 'Mist', size: '250ml', img: BOTTLES.mist250, tagline: 'Everyday hydration, elevated.' },
  { key: 'plus', label: 'Plus', size: '500ml', img: BOTTLES.plus, tagline: 'Alkaline still \u2014 pure wellness.' },
  { key: 'boat', label: 'Boat', size: '1L', img: BOTTLES.boat, tagline: 'A voyage in every drop.' },
  { key: 'neo', label: 'Neo', size: '1L', img: BOTTLES.neo, tagline: 'The future of premium hydration.' },
  { key: 'mist1l', label: 'Mist', size: '1L', img: BOTTLES.mist, tagline: 'Iridescent design. Uncompromising purity.' },
];

// Full product range for the Products section
export const productRange = [
  { name: 'Mini', size: '200', unit: 'ml', img: BOTTLES.mini, tagline: 'Ideal for events, hospitality and airlines.' },
  { name: 'Mist', size: '200', unit: 'ml', img: BOTTLES.mist200, masked: true, tagline: 'Vibrant, playful, on-the-go hydration.' },
  { name: 'Mist', size: '250', unit: 'ml', img: BOTTLES.mist250, tagline: 'Premium compact hydration, everyday.' },
  { name: 'Plus', size: '500', unit: 'ml', img: BOTTLES.plus, tagline: 'Alkaline still \u2014 pure wellness.' },
  { name: 'Boat', size: '1', unit: 'L', img: BOTTLES.boat, tagline: 'For those who chart their own course.' },
  { name: 'Neo', size: '1', unit: 'L', img: BOTTLES.neo, tagline: 'Modern refinement. Everyday elegance.' },
  { name: 'Mist', size: '1', unit: 'L', img: BOTTLES.mist, tagline: 'Iridescent design for family-sized hydration.' },
];
